// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'
import baseurl from '../../../@core/auth/jwt/baseurl'

export const showErrorMsg = (error) => {
  toast.error(
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">Error</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{error?.message || error}</span>
      </div>
    </Fragment>,
    { icon: false, transition: Slide, hideProgressBar: false, autoClose: 3000 }
  )
}

export const checkNameSimilarity = createAsyncThunk(
  'nameSimilarity/check',
  async (input, { rejectWithValue }) => {
    try {
      const response = await baseurl.post('/api/app/name-similarity/check', input)
      return response.data
    } catch (err) {
      const msg = err?.response?.data?.error?.message || err.message
      showErrorMsg(msg)
      return rejectWithValue(msg)
    }
  }
)

const nameSimilaritySlice = createSlice({
  name: 'nameSimilarity',
  initialState: {
    result: null,
    loading: false,
    error: null
  },
  reducers: {
    clearResult: (state) => {
      state.result = null
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkNameSimilarity.pending, (state) => {
        state.loading = true
        state.error = null
        state.result = null
      })
      .addCase(checkNameSimilarity.fulfilled, (state, action) => {
        state.loading = false
        state.result = action.payload
      })
      .addCase(checkNameSimilarity.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearResult } = nameSimilaritySlice.actions
export default nameSimilaritySlice.reducer
